<template>
  <div class="page-template">
    <div class="page-swiper">
      <van-search shape="round" placeholder="输入名称搜索" @click="$router.push('/m/search')">
      </van-search>
    </div>

    <div class="page-content">
      <van-sidebar v-model="activeKey" @change="onChange">
        <van-sidebar-item v-for="item in groupList" :key="item.id" :title="item.name" />
      </van-sidebar>
      <div class="page-goods">
        <div v-if="shopList.length>0">
          <div class="hot-item" v-for="item in shopList" :key="item.id" @click="$router.push('/m/details/' + item.id)">
            <div class="hot-img">
              <img :src="item.front" alt="GEEK" />
            </div>
            <span class="new-price init">{{ item.name }}</span>
          </div>
        </div>

        <empty :text="'暂无相关商品'" v-else></empty>
        <div style="clear:both"></div>
      </div>
    </div>

    <Menu></Menu>
  </div>
</template>

<script>
  import {
    getGroup,
    getGroupShop
  } from "@/api/index";
  import {
    Sidebar,
    SidebarItem
  } from "vant";

  export default {

    data() {
      return {
        shopList: [],
        basic: {},
        activeKey: 0,
        groupList: []
      };
    },
    created() {
      this._getGroup()
    },

    methods: {
      // 获取分类
      _getGroup() {
        getGroup().then((res) => {
          this.groupList = res.data;
          if (res.data.length > 0) {
            this._getGroupShop(res.data[0].id)
          }
        })
      },
      // 获取商品
      _getGroupShop(id) {
        getGroupShop({
          group: id,
          pageIndex: 1,
          pageSize: 1000
        }).then((res) => {
          this.shopList = res.data.data;
        });
      },
      onChange(i) {
        this._getGroupShop(this.groupList[i].id)
        var timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          if (osTop === 0) {
            clearInterval(timer);
          }
        }, 30)
      },



    },
  };
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/clean.css";
  @deep: ~">>>";

  .page-template {
    background-color: rgb(245, 246, 247);
    min-height: 100vh;
    position: relative;
    overflow: hidden;

    .page-swiper {
      .van-cell {
        font-size: .28rem;
        line-height: .28rem;
      }

      .van-search__action {
        font-size: .28rem;
        line-height: .64rem;
      }

      @{deep}.van-icon {
        font-size: .32rem;
        margin-top: .03rem;
      }

      @{deep}.van-field__control {
        font-size: .28rem;
      }
    }

    .page-content {
      margin-bottom: 1rem;
      .van-sidebar {
        width: 1.8rem;
        min-height: calc(100vh - 2rem);
        background: #f8f8f8;
        float: left;
        text-align: center;

        .van-sidebar-item {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        /deep/.van-sidebar-item--select,
        .van-sidebar-item--select:active {
          background-color: #fff;
        }


      }

      .page-goods {
        min-height: calc(100vh - 2rem);
        margin-left: 1.8rem;
        padding: 0.2rem;
        
        background: #ffffff;



        .hot-item {
          width: 33.33%;
          float: left;
          margin-bottom: 0.3rem;

          .hot-img {
            padding: 0 .2rem;
            height: 1.4rem;
            margin-bottom: 0.1rem;

            img {
              width: 100%;
              height: 1.4rem;
              border-radius: 0.1rem;
            }
          }

          .new-price {
            display: block;
            color: #f2270c;
            font-size: 0.26rem;
            line-height: 0.3rem;
            height: 0.3rem;
            font-weight: 600;
            text-align: center;
            font-family: JDZhengHT-EN-Regular;
          }

          .init {
            // text-decoration: line-through;
            font-size: 0.24rem;
            font-weight: 1;
            padding: 0 0.2rem;
            color: #666;
            text-align: center;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }

  }
</style>